/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";

import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import RenderPaymentCode from "./RenderPaymentCode";
import ToggleSwitch from "../../../assets/component/ToggleSwitch/ToggleSwitch.js";
import { mapPaymentMethodDataStatus, mapPaymentMethodData } from "../../../assets/helper.js";
import UpgradeNoticeCard from "./UpgradeNoticeCard";

const paymentMethods = [
  {
    key: "octopus",
    label: "Octopus",
  }
];

export function RenderOctopus(state, func, textObj) {
  if (!state || !func) return;

  const octopusStatus = mapPaymentMethodDataStatus(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const octopusData = mapPaymentMethodData(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const octopusHasQRCode = Boolean(octopusData.code);

  if (state.loading) {
    return (
      <div className="OrgInfo-emptyPage">
        <div className="OrgInfo-center">
          <div className="OrgInfo-btm-load"></div>
        </div>
      </div>
    );
  }

  const currentPlan = state.organizationObj.currentPlan
    ? state.organizationObj.currentPlan.toLowerCase()
    : "";
  const isPremiumPlan = currentPlan === "premium";

  return (
    <div className="RenderOctopus-container">
      {isPremiumPlan ? (
        <>
          <div className="RenderOctopus-verticalLayout">
            <div className="RenderOctopus-octopusLogo" />
            <div className="RenderOctopus-qrCodeContainer">
              <RenderPaymentCode state={state} func={func} paymentMethod={paymentMethods[0]} />
            </div>
            <div className="RenderOctopus-toggleContainer">
              <ToggleSwitch
                checked={octopusStatus.checked}
                onChange={(e) => func.handleUpdatePaymentStatus(e, paymentMethods[0].key)}
                disabled={!octopusHasQRCode}
                disabledMessage={!octopusHasQRCode ? "Please upload a QR code first" : ""}
              />
            </div>
          </div>

          {renderErrorMsg(state.errMsgInfo.submitErr.msg)}
        </>
      ) : (
        <UpgradeNoticeCard onUpgradeClick={func.redirectToOrgBilling} />
      )}
    </div>
  );
}
